<script setup lang="ts">
  import { computed, onMounted, onUnmounted } from 'vue'
  import { useCustomFieldsContext } from '../composables/useCustomFields'

  const props = defineProps<{
    /** System field name used for config lookup and registration */
    name: string
  }>()

  const ctx = useCustomFieldsContext()

  onMounted(() => {
    ctx?.registerSystemField({
      fieldName: props.name
    })
  })

  onUnmounted(() => {
    ctx?.unregisterSystemField(props.name)
  })

  const isVisible = computed(
    () => ctx?.isSystemFieldVisible(props.name) ?? true
  )
</script>

<template>
  <template v-if="isVisible">
    <slot />
  </template>
</template>
